import { FC } from 'react'
import classNames from 'classnames'
import { TagProps as Props } from './types'
import styles from './Tag.module.scss'

const Tag: FC<Props> = ({ color, name, className, isSmall }) => {
  return (
    <small
      className={classNames(styles.tag, className ?? '', {
        [styles['is-small']]: isSmall
      })}
      style={{ color }}
    >
      {name}
    </small>
  )
}

Tag.defaultProps = {
  isSmall: false
}

export default Tag
